export default {
  dadosToast: null,
  spinnerVisivel: false,
  spinnerTexto: '',
  tituloPagina: '',
};
